var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportDataIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.875 16.0004C4.7375 16.0004 3.7655 15.6066 2.959 14.8191C2.1525 14.0316 1.7495 13.0691 1.75 11.9316C1.75 10.9566 2.04375 10.0879 2.63125 9.32539C3.21875 8.56289 3.9875 8.07539 4.9375 7.86289C5.225 6.85039 5.7595 6.00039 6.541 5.31289C7.3225 4.62539 8.2255 4.20664 9.25 4.05664V10.1129L8.05 8.95039L7 10.0004L10 13.0004L13 10.0004L11.95 8.95039L10.75 10.1129V4.05664C12.0375 4.23164 13.1095 4.80989 13.966 5.79139C14.8225 6.77289 15.2505 7.92589 15.25 9.25039C16.1125 9.35039 16.8283 9.72239 17.3973 10.3664C17.9663 11.0104 18.2505 11.7634 18.25 12.6254C18.25 13.5629 17.9218 14.3599 17.2653 15.0164C16.6088 15.6729 15.812 16.0009 14.875 16.0004H5.875Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportDataIcon);
export default __webpack_public_path__ + "static/media/importDataIcon.2c4225702b8ede5a92701b3173adb884.svg";
export { ForwardRef as ReactComponent };